import {
    List,
    EditButton,
    Datagrid,
    TextField,
    Link,
    useRecordContext,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { DeleteWithDialogAction } from '../../common/DeleteWithDialogAction';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const TestimonialLinkComponent = () => {
    const record = useRecordContext();
    return (
        <Link
            to={`/testimonials?filter=${encodeURIComponent(
                JSON.stringify({ categoryId: record.id }),
            )}`}
        >
            Testimonials
        </Link>
    );
};
const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const TestimonialCategoriesList = () => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission('TESTIMONIALS');
    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" />
                    <TestimonialLinkComponent />
                    <FormattedDateTimeField source="createdAt" />
                    {isUpdatable && <EditButton />}
                    {isDeletable && <ConfirmDeleteButton />}
                </Datagrid>
            </List>
        </div>
    );
};
export default TestimonialCategoriesList;
